import { Send } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { confirmDialogUseHook } from '@/components/ui/ConfirmDialog.useHook.ts';
import useBookingBill from '@/features/dashboard/bookingChanges/hooks/useBookingBill.ts';
import useResendChange from '@/features/dashboard/bookingChanges/hooks/useResendChange.ts';
import { changePackageFlowRoute } from '@/features/dashboard/bookingChanges/routes/changePackageFlowRoute.ts';
import ClientAcceptanceNotePanel from './ClientAcceptanceNotePanel.tsx';

interface ResendChangePanelProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  changeId: string;
}

/** Zapisujący milczy, a paczka dalej na niego czeka — link wychodzi jeszcze raz. */
const ResendChangePanel = ({ changeId, ...props }: ResendChangePanelProps) => {
  const { bookingId } = changePackageFlowRoute.useParams();
  const { data: bill } = useBookingBill(bookingId);
  const resend = useResendChange(bookingId, bill?.tourId);
  const { confirmWithCallback } = confirmDialogUseHook();

  return (
    <ClientAcceptanceNotePanel
      title="Brak odpowiedzi zapisującego"
      contentClassName="gap-3 pt-4"
      {...props}
    >
      <p className="text-pretty text-sm leading-normal text-neutral-600">
        Link do akceptacji wyjdzie jeszcze raz, e-mailem i SMS-em. Paczka się
        nie zmienia, a czekanie w panelu „Wymaga uwagi” liczy się od nowa.
      </p>
      <ActionButton
        tone="outline"
        size="sm"
        className="self-start"
        isLoading={resend.isPending}
        onClick={() =>
          confirmWithCallback({
            title: 'Wyślij ponownie',
            description:
              'Zapisujący dostanie jeszcze raz e-mail i SMS z linkiem do akceptacji zmian.',
            confirmText: 'Wyślij ponownie',
            loadingText: 'Wysyłanie...',
            onConfirm: () => resend.mutateAsync(changeId),
          })
        }
      >
        <Send aria-hidden />
        Wyślij ponownie
      </ActionButton>
    </ClientAcceptanceNotePanel>
  );
};

export default ResendChangePanel;
